import { useState, useEffect, useCallback } from 'react';
import useUnauthorize from './useUnauthorize';
import { useToken } from '../common/helper';
import { GetProducts } from '@/apis/onboarding';

interface UseFetchProductsReturn {
  products: unknown[];
  refetchProducts: () => void;
}

const useFetchProducts = (): UseFetchProductsReturn => {
  const { checkTokenExpiry } = useToken();
  const { unauthorize } = useUnauthorize();
  const [products, setProducts] = useState<unknown[]>([]);

  const fetchProducts = useCallback(() => {
    const token = checkTokenExpiry();
    if (!token) {
      return;
    }
    GetProducts(token, null, null)
      .then((res) => {
        const responseData = res?.data;
        if (
          responseData?.data?.is_success &&
          Array.isArray(responseData?.data?.data)
        ) {
          setProducts(responseData.data.data);
        } else {
          setProducts([]);
        }
      })
      .catch((err) => {
        unauthorize(err);
        setProducts([]);
      });
  }, [checkTokenExpiry, unauthorize]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, refetchProducts: fetchProducts };
};

export default useFetchProducts;
